import { useState } from 'react';
import { HistoryStepHeader, IHistoryStepHeaderProps } from './HistoryStepHeader/HistoryStepHeader';
import { HistoryStepEvents, IHistoryEventItem } from './HistoryStepEvents/HistoryStepEvents';

import './ToolHistoryStepper.scss';

/**
 * Stepper vertical que renderiza los pasos del historial
 * @param steps - Lista de pasos
 */
export const ToolHistoryStepper = ({ steps }: IToolHistoryStepperProps) => {
  const [expandedSteps, setExpandedSteps] = useState<Set<number>>(new Set([0]));

  const toggleStep = (stepIdx: number) => {
    setExpandedSteps(prev => {
      const newSet = new Set(prev);
      if (newSet.has(stepIdx)) newSet.delete(stepIdx);
      else newSet.add(stepIdx);
      return newSet;
    });
  };

  return (
    <div className="toolHistoryStepper">
      {steps.map((step, stepIdx) => {
        const { header, events } = step;
        const { isCancelled } = header;
        const isCancelledClass = isCancelled ? 'cancelled' : '';
        const hasEvents = !!events?.length;
        const isExpanded = expandedSteps.has(stepIdx);

        return (
          <div key={stepIdx} className={`stepContainer ${isCancelledClass}`}>
            <div className="stepLine"></div>
            <HistoryStepHeader
              {...header}
              isExpandable={hasEvents}
              isExpanded={isExpanded}
              onToggle={() => toggleStep(stepIdx)}
            />
            {hasEvents && isExpanded && <HistoryStepEvents events={events} />}
          </div>
        );
      })}
    </div>
  );
};

export interface IHistoryStep {
  header: IHistoryStepHeaderProps;
  events?: IHistoryEventItem[];
}

interface IToolHistoryStepperProps {
  steps: IHistoryStep[];
}
